/** Code-owned inventory. User content must never become tool instructions. */
export const WEBMCP_ACTIONS = {
  navigate_site: "R1", open_navigation: "R1", set_locale: "R1", select_persona: "R1",
  set_theme: "R1", skip_to_content: "R1", open_legal_page: "R1",
  start_booking: "R2", start_email_contact: "R2", start_phone_contact: "R2",
  start_whatsapp_contact: "R2", follow_cta: "R2",
  list_services: "R0", get_service: "R0", list_pricing: "R0", list_case_studies: "R0",
  get_case_study: "R0", search_content: "R0",
  submit_service_lead: "R3", request_lead_magnet: "R3",
  submit_manual_transfer_details: "R3", request_funnel_handoff: "R3",
  calculate_resource_estimate: "R1", configure_package: "R1",
  run_gamification_calculator: "R1", score_assessment: "R1",
  recommend_service_path: "R1", update_checklist: "R1",
  build_funnel_plan: "R1", compute_projection: "R0", reverse_goal: "R0",
  edit_funnel_canvas: "R1", compare_scenarios: "R0", apply_advisory: "R1",
  create_share_link: "R2", export_funnel_plan: "R2",
  copy_canonical_link: "R2", open_linkedin_share: "R2",
  set_consent_preferences: "R3", close_privacy_dialog: "R1",
  request_portal_magic_link: "R3", request_oauth_magic_link: "R3",
  approve_oauth_consent: "R3", sign_out: "R3",
} as const;
export type WebMcpAction = keyof typeof WEBMCP_ACTIONS;
export type WebMcpRisk = (typeof WEBMCP_ACTIONS)[WebMcpAction];
export const WEBMCP_SPEC_REVISION = "2026-09-04";
export const WEBMCP_TOOL_PREFIX = "seoh_";
export function webMcpToolName(action: WebMcpAction, instance?: string) {
  if (instance && !/^[a-z0-9_]{1,80}$/.test(instance)) throw new Error("invalid_instance");
  return `${WEBMCP_TOOL_PREFIX}${action}${instance ? `_${instance}` : ""}`;
}
